<template>
  <modal :modal-key="'operator_selection_modal'" @close="$emit('close')" class="modal--welcomeback modal--zero-balance alter_flow">
    <template slot="header">
      <p class="top_disclaimer_extra">
        {{ showUpperDisclaimer() }}
      </p>
      <h1>{{ getTranslations.home_modals_select_operator_register }}</h1>
      <img :src="getTranslations.project_config_modal_img" alt="">
      <img class="duel_modal_logo" src="static/images/logo_center.png">
    </template>
    <template slot="body">
      <div class="operators_selection_wrap">
        <h1>{{ getTranslations.visitor_sign_up_1_single_country_my_operator }}</h1>
        <p>{{ getTranslations.home_modals_select_operator_my_operator_is }} </p>
        <div :class="getClassForOperatorRadioGroup()">
          <label v-for="(operator, index) in multiOperatorInfo.multiOperatorKeys"
                 v-if="multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage[index]"
                 :class="getClassForOperatorRadio()"
                 :key="index">
            <img :class="getClassForOperatorImage()"
                 :src="getOperatorImage(index)"
                 :alt="getOperatorDisplayName(index)">
            <input type="radio"
                   name="operator"
                   :value="operator"
                   v-model="inputOperator"
                   @click="check();getOrdinalByOperator(operator);tpayWifiFlow(operator)">
            <span></span>
          </label>
        </div>
        <div class="operators_error_msg"
             v-if="!inputOperator && btnSubmitted">
              <span class="form-group__feedback">
                {{ getTranslations.visitor_sign_up_1_single_country_select_operator }}
              </span>
        </div>
      </div>
      <a>{{ getAbovePlaceholderText() }}</a>
      <form action="" v-on:submit.prevent="goToNext()">
        <div :class="[ 'form-group', !errors ? 'has-success' : 'has-warning' ]">
          <input type="text"
                 class="form-group__textfield phone_input"
                 :placeholder="getPlaceholder()"
                 @keyup="check"
                 v-model="inputMsisdn"/>
          <span class="form-group__feedback"
                v-if="ERROR_REDIRECT_MESSAGE">
                {{ getMessage(mapErrorMessages(ERROR_REDIRECT_MESSAGE)) }}
              </span>
        </div>
        <a @click.prevent="goToNext()"
           style="cursor:pointer"
           :class="['btn2 btn2--std btn2--small', (errors)? 'deactivated' : '']">
          {{ getTranslations.visitor_sign_up_1_single_country_submit_button_continue }}
        </a>
        <br/>
        <br/>
        <a style="cursor: pointer"
           @click.prevent="exit()">
          {{ getExitButtonText() }}
        </a>
      </form>
      <p class="top_disclaimer_extra">
        {{ showExtraDisclaimer() }}
      </p>
      <p  v-if="showDisclaimer()">
        {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'visitor_operator_selection_modal_disclaimer') }}
      </p>
      <p class="form-group__feedback reg_notice" v-if="inputOperator">
        {{ getTranslations.visitor_operator_selection_modal_terms_conditions }}
        <a style="cursor: pointer"
           target="_blank"
           :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')">
          {{ getTranslations.visitor_operator_selection_modal_terms_conditions_click }}
        </a>
      </p>
    </template>
  </modal>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';

export default {
  name: 'operatorSelectionModal',
  components: {
    Modal,
  },
  created() {
    this.inputMsisdn = (this.getTranslations.visitor_msisdn_input_prefix_value) ? this.getTranslations.visitor_msisdn_input_prefix_value : '';
    const numOfVisibleOperators = (this.multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage.filter(item => item)).length;
    if (numOfVisibleOperators === 1) {
      const position = this.multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage.indexOf(true);
      const operator = this.multiOperatorInfo.multiOperatorKeys[position];
      this.storeOperator(operator);
      this.inputOperator = operator;
    }
  },
  data() {
    return {
      inputMsisdn: '',
      inputOperator: '',
      errors: false,
      btnSubmitted: false,
    };
  },
  methods: {
    ...mapMutations('profile', [
      'setRegistrationInfo',
    ]),
    ...mapMutations('common', [
      'updateMultiOperatorOrdinal',
    ]),
    ...mapActions('common', [
      'storeOperator',
      'convertArabicNumbers',
    ]),
    getClassForOperatorRadioGroup() {
      return this.hasResub() ? 'operatorsmulti_radio' : 'operators_radio';
    },
    getClassForOperatorRadio() {
      return this.hasResub() ? ['operatorsmulti_radio', 'operatorsmulti_radio_inline'] : ['operators_radio', 'operators_radio_inline'];
    },
    getClassForOperatorImage() {
      return this.hasResub() ? 'operatorsmulti_icon' : 'operators_icon';
    },
    exit() {
      window.location.href = 'https://google.com';
    },
    getPlaceholder() {
      if (!this.inputOperator) return this.getTranslations.visitor_sign_up_1_single_country_placeholder;
      return this.getTranslationByOperatorIfExists(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_operator_selection_modal_placeholder');
    },
    getExitButtonText() {
      if (!this.inputOperator) return '';
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_exit');
    },
    getAbovePlaceholderText() {
      if (!this.inputOperator) return this.getTranslations.visitor_sign_up_1_single_country_above_placeholder;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_single_country_above_placeholder');
    },
    showExtraDisclaimer() {
      if (!this.inputOperator) return '';
      return this.getTranslationByOperatorIfExists(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_operator_selection_modal_extra_disclaimer');
    },
    showDisclaimer() {
      if (this.multiOperatorInfo.multiOperatorEnabled) {
        return this.inputOperator;
      }
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_operator_selection_modal_disclaimer');
    },
    showUpperDisclaimer() {
      if (!this.inputOperator) return '';
      return this.getTranslationByOperatorIfExists(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_operator_selection_modal_upper_disclaimer');
    },
    mapErrorMessages(resMessage) {
      if (resMessage === 'MSISDN_INVALID') {
        return 'visitor_sign_up_invalid_msisdn_msg';
      } else if (resMessage === 'ALREADY_REGISTERED') {
        return 'visitor_sign_up_msisdn_already_registered';
      } else if (resMessage === 'MSISDN_NOT_EXIST') {
        return 'visitor_sign_up_msisdn_not_exists';
      } else if (resMessage === 'MSISDN_BLACKLISTED') {
        return 'visitor_sign_up_msisdn_blacklisted';
      } else if (resMessage === 'BLOCKED_USER') {
        return 'visitor_forgot_password_warning_msd_max_attempts';
      } else if (resMessage === 'DUPLICATE') {
        return 'visitor_sign_up_duplicate_request';
      } else if (resMessage === 'SERVER_ERROR') {
        return 'home_profile_profile_edit_server_unvailable';
      } else if ((resMessage === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (resMessage === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (resMessage === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
        return 'visitor_sign_up_warning_third_party_error';
      }
      return '';
    },
    getOrdinalByOperator(operator) {
      this.$axios.get(`publicapi/getMultiOperatorConfigProperties?operatorKey=${operator}`).then((res) => {
        this.updateMultiOperatorOrdinal({ value: res.data.data.multiOperatorOrdinal });
      });
    },
    tpayWifiFlow(operator) {
      /* eslint-disable */
      console.log(operator);
      if (this.getIntegrationConfig.integrationKey === this.availableIntegrations.TPAY_EGYPT) {
        const code = this.getOperatorCode(operator);
        console.log('operator: ', operator, ' opCode: ', code);
        sessionStorage.setItem('operator', operator);
        TPay.HeaderEnrichment.init({ operatorCode: code });
        /* eslint-enable */
      }
    },
    check() {
      let validMsisdnRegex = /^[0-9]{0,20}$/;
      if (this.conversionForArabicFields) validMsisdnRegex = /^[٠١٢٣٤٥٦٧٨٩0-9]{0,20}$/;
      const validMsisdn = this.inputMsisdn.match(validMsisdnRegex);
      if (!validMsisdn) {
        this.ERROR_REDIRECT_MESSAGE = 'MSISDN_INVALID';
        this.errors = true;
      } else {
        this.errors = false;
        this.ERROR_REDIRECT_MESSAGE = '';
      }
    },
    getOperatorCode(operator) {
      let code;
      switch (operator) {
      case 'ORANGE_EGY':
        code = '60201';
        break;
      case 'VODAFONE_EGY':
        code = '60202';
        break;
      case 'ETISALAT_EGY':
        code = '60203';
        break;
      case 'WE_EGY':
        code = '60204';
        break;
      default:
        break;
      }
      return code;
    },
    async prepareConfirm() {
      /* eslint-disable */
      if (this.getIntegrationConfig.integrationKey === this.availableIntegrations.TPAY_EGYPT) {
        let msisdn = this.inputMsisdn;
        if (this.inputMsisdn.startsWith('01')) { // Transformation from 01 to 201
          msisdn = '2' + msisdn;
        }

        console.log('Transformed msisdn: ', msisdn);

        if (this.inputMsisdn.length > 5) { // msisdn field gets filled up
          let obj = {
            msisdn: msisdn,
            subscriptionPlanId: '1519',
            productCatalog: 'catalog',
            productSku: 'sub_product',
            operatorCode: this.getOperatorCode(sessionStorage.getItem('operator')),
            customerAccountNumber: sessionStorage.getItem('can'),
          };

          console.log('Confirm return obj = ', obj);

          try {
            TPay.HeaderEnrichment.confirm(obj,
              async function (status, refCode, contract) {
                console.log('status: ' + status + ' refcode: ' + refCode + ' contract: ' + contract);

                if (status === true) { // No error or fail case
                  sessionStorage.setItem('status', status);
                  sessionStorage.setItem('refcode', refCode);
                  sessionStorage.setItem('contract', contract);

                  // Wifi flow
                  const sessionToken = await TPay.HeaderEnrichment.sessionToken();
                  console.log('Got sessionToken: ', sessionToken);
                }
              }
            );

          } catch (error) {
            console.error(error);
            return false;
          }
          const sessionToken = await TPay.HeaderEnrichment.sessionToken();
          sessionStorage.setItem('sessionToken', sessionToken);
        }
      }
      return true;
      /* eslint-enable */
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, key) || '';
    },
    getOperatorImage(operatorIndex) {
      return this.getTranslationByOperator(operatorIndex, 'visitor_sign_up_1_operator_image');
    },
    getOperatorDisplayName(operatorIndex) {
      return this.multiOperatorInfo.multiOperatorDisplayNames[operatorIndex];
    },
    async goToNext() {
      if (this.getIntegrationConfig.integrationKey === this.availableIntegrations.TPAY_EGYPT) {
        const nextStepCall = await this.prepareConfirm();
        // eslint-disable-next-line
        console.log('NEXT STEP CALL: ', nextStepCall);
        if (nextStepCall) {
          this.nextSteps();
        }
      } else {
        this.nextSteps();
      }
    },
    nextSteps() {
      this.btnSubmitted = true;
      if (this.inputMsisdn && this.inputOperator) {
        if (this.conversionForArabicFields) {
          this.convertArabicNumbers(this.inputMsisdn).then((res) => {
            if (res.responseEnum === 'OPERATION_SUCCESS') {
              this.registrationFlow(res.data);
            } else {
              this.ERROR_REDIRECT_MESSAGE = 'MSISDN_INVALID';
              this.errors = true;
            }
          });
        } else {
          this.registrationFlow(this.inputMsisdn);
        }
      } else {
        this.errors = true;
      }
    },
    registrationFlow(msisdn) {
      this.setRegistrationInfo(msisdn);
      this.storeOperator(this.inputOperator);
      const appropriateRequestPinStep = this.getAlternateRequestPinAction(); // integration specific
      if (appropriateRequestPinStep) {
        appropriateRequestPinStep.call(this, msisdn, this.inputOperator);
      } else { // default
        this.setActiveIntegrationInfo([{ key: 'msisdn', value: msisdn }, { key: 'operator', value: this.inputOperator }, { key: 'lang', value: this.getLocale }]);
        this.registrationRedirection();
      }
    },
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
      'conversionForArabicFields',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
      'getTranslationByOperatorIfExists',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/flow/OperatorSelectionModal.vue